import { ChangeEvent, useMemo } from "react"
import { PageType } from "../../../../pages/_app"
import { useLayoutData } from "../../../../utils/contexts/LayoutContext"
import dynamic from "next/dynamic"
import { FormControlLabelProps } from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import { FilterBaseProps } from "../Find.types"
import { useRouter } from "next/router"
import FindFilterMobileListItem from "../FindFilterMobileListItem"
import { filterUrl } from "../Find"
import { FindRadioButtonProps } from "../FindDesignTypes";

const FilterRadioButtons = ({
	filters,
  colors,
  pageUrl,
  mmbr,
  isMobile,
  closeSubmenu
}: FilterBaseProps) => {
	const router = useRouter()
	const { partnerSiteFull, templatePath } = useLayoutData()

	const path = templatePath === PageType.RBhuPP ? `${templatePath}/templates/${partnerSiteFull?.content?.templateId ?? 'AutoraTemplate'}` : templatePath

	const FindFormControlLabel = useMemo(() => dynamic<FormControlLabelProps>(() => import(`../../../../design/${path}/_findDesign/Design`).then((style) => style.FindFormControlLabel)), [path])
	const FindRadioButton = useMemo(() => dynamic<FindRadioButtonProps>(() => import(`../../../../design/${path}/_findDesign/Design`).then((style) => style.FindRadioButton)), [path])

	const titleFormatter = (title: string, count: number) => {
		const splitted = title.split('-')
		const hasSecond = Boolean(splitted[1])

		return (
			<Grid container spacing={1}>
				<Grid item xs={hasSecond ? "auto" : 11}>{splitted[0]}</Grid>
				{hasSecond ? (
					<>
						<Grid item xs={"auto"}>-</Grid>
						<Grid item xs={true}>{splitted[1]}</Grid>
					</>
				) : null}
				<Grid item xs={1}><span className="filter-count">({count})</span></Grid>
			</Grid>
		)
	}

	const handleRadioChange = (e: ChangeEvent<HTMLInputElement>) => {
		const url = e.target.value
		router.push(filterUrl(filters, undefined, url, pageUrl, mmbr), undefined, { scroll: false })
	}

	return (
		isMobile ? (
			<>
          {filters?.items?.map((item, i) => (
              <FindFilterMobileListItem
                key={i}
                filters={filters}
                item={item}
                colors={colors}
                pageUrl={pageUrl}
                mmbr={mmbr}
                closeSubmenu={closeSubmenu}
              />
            )
          )}
        </>
		) : (
			<>
				{filters?.items?.map((item, i) => (
					<FindFormControlLabel
						key={i}
						control={
							<FindRadioButton
								size={"small"}
								checked={item.selected ?? false}
								disabled={item.disabled ?? false}
								value={item.targetUrl}
								onChange={handleRadioChange}
								inputProps={{
									"aria-label": item?.title
								}}
								bgcolor={colors.mainColor}
							/>
						}
						label={titleFormatter(item.title as string, item.count as number)}
					/>
				))}
			</>
		)
	)
}

export default FilterRadioButtons